import { render, staticRenderFns } from "./DiseaseItem.vue?vue&type=template&id=580bd294&scoped=true"
import script from "./DiseaseItem.vue?vue&type=script&lang=js"
export * from "./DiseaseItem.vue?vue&type=script&lang=js"
import style0 from "./DiseaseItem.vue?vue&type=style&index=0&id=580bd294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580bd294",
  null
  
)

export default component.exports